module.exports = "//static.hsappstatic.net/ContentComponents/static-2.62696/img/payment_methods.png"